import { jsx as i } from "react/jsx-runtime";
import "@market/market-theme/css/core/index.css";
import { themeVariables as b } from "@market/tidal-theme/dist/js/theme-overrides/dark-mode.js";
import { themeVariables as w } from "@market/tidal-theme/dist/js/theme-overrides/index.js";
import { createContext as N, useState as S, useContext as V, useEffect as j } from "react";
import L from "../../utils/camelToCustomProperty.js";
const R = {
  market: { light: {}, dark: {} },
  monochrome: { light: {}, dark: {} },
  tidal: { light: w, dark: b }
}, $ = (e) => {
  const t = {};
  return Object.entries(e ?? {}).forEach(([m, s]) => {
    s !== void 0 && (t[L(m)] = s);
  }), t;
}, y = (e, t) => e === "system" ? t ? "dark" : "light" : e ?? "light", M = (e) => e !== void 0 && Object.keys(e).length > 0, E = Symbol("unset"), d = N(E), D = (e) => {
  const {
    children: t,
    mode: m,
    portal: s,
    theme: a,
    tokens: c
  } = e, [h, O] = S(
    () => typeof window < "u" && !!window.matchMedia?.("(prefers-color-scheme: dark)")?.matches
  ), l = V(d), k = l === E, o = k ? void 0 : l, n = a ?? o?.theme ?? "monochrome", p = m ?? o?.mode ?? "light", r = y(p, h), v = R[n][r], u = { ...a !== void 0 && a !== o?.theme ? {} : o?.tokens ?? {}, ...c ?? {} }, x = { ...v, ...u }, C = $(x);
  j(() => {
    const T = window?.matchMedia?.("(prefers-color-scheme: dark)"), g = (P) => O(P.matches);
    return T?.addEventListener("change", g), () => T?.removeEventListener("change", g);
  }, []);
  const f = { mode: p, theme: n, tokens: u };
  return !k && !s && n === o?.theme && r === y(o?.mode ?? "light", h) && !M(c) && !M(v) ? /* @__PURE__ */ i(d.Provider, { value: f, children: t }) : /* @__PURE__ */ i(d.Provider, { value: f, children: /* @__PURE__ */ i(
    "div",
    {
      "data-market-theme": `${n} ${r}-mode`,
      "data-market-mode": r,
      style: {
        display: "contents",
        colorScheme: r,
        ...C
      },
      children: t
    }
  ) });
};
D.displayName = "MarketTheme";
export {
  D as MarketTheme
};
